import type {HTMLChakraProps} from '@chakra-ui/react';
import {ChakraSpan} from '@linx-security/ui/utils/chakra-elements';
import cx from 'clsx';
import type {Property} from 'csstype';

import {mergeSXProp} from '../../utils/merge-sx-prop';

export type DotProps = HTMLChakraProps<'span'> & {
  fill?: HTMLChakraProps<'span'>['color'];
  size?: `sm` | `md` | Property.Width | Property.Height;
};

export const Dot = ({className, sx = {}, fill, size = `md`, ...restProps}: DotProps) => {
  const width = getSize(size);
  const height = getSize(size);
  const backgroundColor = fill || `brand.success.500`;

  return (
    <ChakraSpan
      className={cx(`dot`, className)}
      sx={mergeSXProp(sx, {
        borderRadius: `100%`,
        backgroundColor,
        height,
        width,
        minWidth: width,
      })}
      backgroundColor={backgroundColor}
      {...restProps}
    />
  );
};

const getSize = (size: DotProps['size']) => {
  if (size === `sm`) {
    return `4px`;
  }
  if (size === `md`) {
    return `6px`;
  }
  return size;
};
